export type Metric = {
  key: string;
  label: string;
  value: number;
  delta_pct: number | null;
  series: number[] | null;
  format: 'money' | 'count' | 'percent';
};

// Metrics where an increase is unfavorable (shown red even with an up arrow).
const UP_IS_BAD = new Set(['mtd_expenses', 'ar_overdue', 'ap_due', 'open_po_value']);

export function deltaMeta(metricKey: string, deltaPct: number | null):
  { up: boolean; favorable: boolean; pct: number } | null {
  if (deltaPct == null) return null;
  const up = deltaPct >= 0;
  const bad = UP_IS_BAD.has(metricKey);
  return { up, favorable: up ? !bad : bad, pct: Math.abs(deltaPct) };
}
